import { Skeleton } from '@/lib/base/skeleton/skeleton';

export function DetectingPlatform() {
  return (
    <div aria-busy='true' aria-label='Loading' className='flex flex-col gap-6'>
      <Skeleton height={180} variant='rectangular' />
      <div className='flex flex-col gap-3'>
        <Skeleton variant='text' width='60%' />
        <Skeleton variant='text' width='40%' />
      </div>
    </div>
  );
}
